import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'unit',
  standalone: true,
})
export class UnitPipe implements PipeTransform {
  transform(value: number, _addInfo: any, measurementSystem: any): string {
    if (!value) return '';
    return `${value} ${measurementSystem}`;
  }
}
